<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <form>
                <vx-card>
                    <vs-row vs-w="12" class="mb-5">
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="1" vs-sm="4" vs-xs="12">
                            <vs-button @click="goBack" color="danger" type="border" icon="keyboard_backspace">Back</vs-button>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="4" vs-xs="12">
                            <h3>Opportunity Alerts</h3>
                        </vs-col>
                        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
                        </vs-col>
                    </vs-row>
    
                    <DataGrid :rowSelection="'single'" :context="'OpportunityAlerts'" @emailOpportunityAlert="emailOpportunityAlert" @editClientViewDetails=editSDViewDetails @createOpportunityDocsFile="createOpportunityDocsFile" ref="OpportunityAlerts" :sideBar=sideBar :columnDefs="columnDefs" :rowData="records" :dataSource="dataSource">
                    </DataGrid>
                </vx-card>
            </form>
        </div>
        <vs-popup title="Create Opportunity Document" :active.sync="showOpportunityDocumentPopUp">
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>Name:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-input class="w-full" name="name" v-model="opportunity_document.name" v-validate="'required'" data-vv-as="Name" />
                    <span class="text-danger text-sm mt-2" v-show="errors.has('name')">{{ errors.first("name") }}</span>
    
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                    <span>Description:</span>
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-textarea name="description" v-model="opportunity_document.description" />
                </div>
            </div>
            <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/5 w-full">
                </div>
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-button @click.prevent="submitCreateDocumentForm">Submit</vs-button>
    
                </div>
            </div>
        </vs-popup>
    
        <vs-popup :title="'Update Details'" fullscreen :active.sync="editClientViewPopUp">
            <div class="text-center ">
                <u>
                    <h2 class="pb-5">Account</h2>
                </u>
            </div>
    
            <template v-for="(value,key) in editSelectedAccount">
      

                <template v-for="field_array_column in  editSelectedAccount['campaign_data_options']">
      
              
      
      
                   <template v-if="field_array_column.column_id == key && field_array_column.identifier != 'phone_type' && field_array_column.identifier != 'phone_code'">
      
      
        
                    <div class="vx-row mb-6">
      
                      <div class="vx-col sm:w-1/5 w-full">
      
                        <template v-if="field_array_column.identifier != 'switchboard_phone_code'">
                          <span>{{ field_array_column.name }} </span>
      
                        </template>
                        <!-- {{ field_array_column.column_id }} -->
                      </div>
                     
                      <div class="vx-col sm:w-2/3 w-full">
                        <div class="vx-col sm:w-2/3 w-full">
      
                          <!-- {{field_array_column}} -->
        
        
                         <template v-if="field_array_column.identifier == 'registered_office_country'">
        
                          <v-select name="registered_office_country" class="registered_office_country" label="name_1"
                          :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                         </template>
        
                         <template v-else-if="field_array_column.identifier == 'head_office_country'">
                          <v-select name="head_office_country" class="head_office_country" label="name_1"
                          :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                        
                        </template>
        
                        <template v-else-if="field_array_column.identifier == 'registration_jurisdiction'">
                          <v-select name="registration_jurisdiction" class="registration_jurisdiction" label="name_1"
                          :options="all_countries" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                        
                        </template>
        
        
        
                        <!-- <template v-else-if="field_array_column.identifier == 'phone_type'">
                          <div class="vx-col sm:w-1/3 w-full">
                            <v-select 
                              label="name" :options="phoneTypes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                          </div>
                        </template>
        
                        
        
                        <template v-else-if="field_array_column.identifier == 'phone_code'">
        
                          <div class="vx-col sm:w-1/3 w-full">
                            <v-select 
                              label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                          </div>
                        </template> -->
      
      
                        <template v-else-if="field_array_column.identifier == 'phone'">


      
      
                          <template
                          v-for="(w, index) in editSelectedAccount[key]"
                        >
      
                          <div class="flex mb-4">
      
      
      
                            <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                              <v-select
                              name="phone_code"
                              class="phone_code"
                              label="name_with_code"
                              :options="all_phone_codes"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                              v-model="editSelectedAccount[key][index]['phone_code']"
                            />
                              </div>
          
                              <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                                <vs-input
                                class="w-full"
                                name="phone"
                                v-model="editSelectedAccount[key][index]['phone_no']"
                              />
                              </div>
                              <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                                <v-select
                                  label="slug"
                                  :options="phoneTypes"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="editSelectedAccount[key][index]['phone_type']"
                                />
                                <!-- <vs-input class="w-full mb-2" v-model="d.phone_type" /> -->
                              </div>
      
      
      
                             
      
      
                            
                            <div class="w-1/5 bg-grid-color h-12">
                              <vs-icon
                                class="removeButton"
                                @click="removeSelectedPhone(key, w)"
                                color="success"
                                icon="clear"
                              >
                              </vs-icon>
                            </div>
                          </div>
                        </template>
      
      
                    
                          <vs-button
                        @click="addPhone(field_array_column.column_id)"
                        color="primary"
                        type="filled"
                        >Add</vs-button
                      >
                        </template>
                        
                        <template v-else-if="field_array_column.identifier == 'switchboard_phone_code'">
                          </template>
      
        
                        <template v-else-if="field_array_column.identifier == 'switchboard'">
      
                          <div class="flex mb-4">
      
                          <div class="w-1/4 bg-grid-color-secondary h-12 mr-5">
                            <v-select 
                              label="phone_code" :options="all_phone_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount['_e4329196_efa0_417b_93a2_e12ec28ece85']" />
                          </div>
      
      
                          <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
      
                          <vs-input
                          class="w-full" v-model="editSelectedAccount[key]" :name="field_array_column.column_id" 
                           :data-vv-as="field_array_column.column_id" />
      
                           </div>
                           </div>
      
      
                        </template>
        
                        <template v-else-if="field_array_column.identifier == 'sic_code'">
                          <div class="vx-col sm:w-1/3 w-full">
        
                            <v-select 
                            label="code" :options="all_sic_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                        </div>
                           
                        </template>
        
                        <template v-else-if="field_array_column.identifier == 'vertical'">
                          <div class="vx-col sm:w-1/3 w-full">
        
                            <v-select 
                            label="vertical" :options="all_verticals" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                        </div>
                           
                        </template>
      
                        <template v-else-if="field_array_column.identifier == 'revenue'">
                          <div class="vx-col sm:w-1/3 w-full">
      
      
                            <input type="number" 
                            class="vs-input-class" v-model="editSelectedAccount[key]" :name="field_array_column.column_id"
                             :data-vv-as="field_array_column.column_id" />
        
                           
                        </div>
                           
                        </template>
      
                        <template v-else-if="field_array_column.identifier == 'no_of_employees'">
                          <div class="vx-col sm:w-1/3 w-full">


      
      
                            <input type="number" 
                            class="vs-input-class" v-model="editSelectedAccount[key]" :name="field_array_column.column_id"
                             :data-vv-as="field_array_column.column_id" />
        
                           
                        </div>
                           
                        </template>
        
                        <template v-else-if="field_array_column.identifier == 'currency_code'">
                          <div class="vx-col sm:w-1/3 w-full">
        
                            <v-select
                            label="code" :options="all_currency_codes" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedAccount[key]" />
                        </div>
                           
                        </template>
      
                        <template v-else-if="field_array_column.identifier == 'website'">
      
      
                          <template
                          v-for="(w, index) in editSelectedAccount[key]"
                        >
      
                          <div class="flex mb-4">
                            <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                              <vs-input
                                class="w-full"
                                name="website_url"
                                v-validate="'url:require_protocol'"
                                v-model="editSelectedAccount[key][index]['url']"
                                data-vv-as="website"
                              />
                            </div>
                            <div class="w-1/5 bg-grid-color h-12">
                              <vs-icon
                                class="removeButton"
                                @click="removeSelectedWeb(key, w)"
                                color="success"
                                icon="clear"
                              >
                              </vs-icon>
                            </div>
                          </div>
                        </template>
      
                        <vs-button
                        @click="addWebsite(field_array_column.column_id)"
                        color="primary"
                        type="filled"
                        >Add</vs-button
                      >
                           
                        </template>
      
                        <template v-else-if="field_array_column.identifier == 'linkedin'">
      
      
                          <template
                          v-for="(w, index) in editSelectedAccount[key]"
                        >
      
                          <div class="flex mb-4">
                            <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                              <vs-input
                                class="w-full"
                                name="url"
                                v-validate="'url:require_protocol'"
                                v-model="editSelectedAccount[key][index]['url']"
                                data-vv-as="linkedin"
                              />
                            </div>
                            <div class="w-1/5 bg-grid-color h-12">
                              <vs-icon
                                class="removeButton"
                                @click="removeSelectedLinkedin(key, w)"
                                color="success"
                                icon="clear"
                              >
                              </vs-icon>
                            </div>
                          </div>
                        </template>
      
                        <vs-button
                        @click="addLinkedIn(field_array_column.column_id)"
                        color="primary"
                        type="filled"
                        >Add</vs-button
                      >
                           
                        </template>
                        
        
        
        
                        <template v-else>
      
      
                          <template v-if="field_array_column.identifier == 'none_core_field'">
      
      
      
      
      
      
                            <template v-if="field_array_column.type == 'number'">
                              <input type="number" 
                                class="vs-input-class" v-model="editSelectedAccount[key]" :name="field_array_column.column_id"
                                 :data-vv-as="field_array_column.column_id" />
      
                                
      
      
      
                              </template>
        
                              <template v-else-if="field_array_column.type == 'text' || field_array_column.type == 'client_contact'">
                                <vs-input
                                  class="w-full" v-model="editSelectedAccount[key]" :name="field_array_column.column_id" v-validate="field_array_column.mandatory?'required':''"
                                   :data-vv-as="field_array_column.column_id" />
                                 
                              </template>
        
                              <template v-else-if="field_array_column.type == 'date'">
      
                                <flat-pickr
                                  :config="configDatePicker"
                                  placeholder="Choose Date"
                                  name="audit_date_time"
                                  v-model="editSelectedAccount[key]"
                                />
                              </template>

                                <template v-else-if="field_array_column.type == 'datetime'">
      
                                <flat-pickr
                                  :config="configDateAndTimePicker"
                                  placeholder="Choose Date And Time"
                                  name="audit_date_and_time"
                                  v-model="editSelectedAccount[key]"
                                />
                              </template>
        
                              <template v-else-if="field_array_column.type == 'choose_one'">
      
      
                                <span v-for="val, k in JSON.parse(field_array_column.values)">
      
                                  <input class="ml-4" :name="key" :value="val.value" type="radio" v-model="editSelectedAccount[key]" />
                                  {{ val.value }}
                                </span>
      
                                <!-- <v-select
                                  label="value"
                                  :name="key"
                                  :options="JSON.parse(field_array_column.values)"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="editSelectedAccount[key]"
                                  v-validate="'required'"
                                  data-vv-as="Action Type"
                                /> -->
                              </template>
        
                              <template v-else-if="field_array_column.type == 'dropdown'">
      
      
                                <v-select
                                  label="value"
                                  :name="key"
                                  :options="JSON.parse(field_array_column.values)"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="editSelectedAccount[key]"
                                  v-validate="'required'"
                                  data-vv-as="Action Type"
                                />
                              </template>
        
                              <template v-else-if="field_array_column.type == 'checkbox'">
      
      
      
                                <span v-for="(v, v_key) in JSON.parse(field_array_column.values)" class="p-2">
      
                                
                                  <input
                                    type="checkbox"
                                    class="mr-2"
                                    :value="v.value"
                                    :id="field_array_column.column_id"
                                              v-model="editSelectedAccount[key]"
                                    :checked="
                                    editSelectedAccount[key] != null &&
                                    editSelectedAccount[key].includes(v.value)
                                    "
                                   
                                  />
                    
                                  {{ v.value }}
                                </span>
      
                              
                              </template>
      
                              <template v-else-if="field_array_column.type == 'textarea'">

                                <div :class="'textarea' + field_array_column.column_id">

                                <vue-trumbowyg v-model="editSelectedAccount[key]" 
                                :config="configs.basic"></vue-trumbowyg>

                                </div>
                         
        
      
                            </template>
                          </template>
      
                            <template v-else>
      
                             
      
      
                              <vs-input
                              class="w-full" v-model="editSelectedAccount[key]" :name="field_array_column.column_id" 
                               :data-vv-as="field_array_column.column_id" />
                               
      
                            </template>
      
        
                       
                     
              
                     </template>
                          </div>
              </div>
                    </div>
                   </template>
        
        
                </template>
        
        
              </template>
    
       
    
            <vs-divider />
    
            <div class="text-center ">
                <u>
                    <h2 class="pb-5">Contact</h2>
                </u>
            </div>
            <div class="vx-col w-full">
            </div>
            <template v-for="(value,key) in editSelectedContact">
      

                <template v-for="field_array_column in  editSelectedContact['campaign_data_options']">
        
                  
        
        
                   <template v-if="field_array_column.column_id == key && field_array_column.level == 'contact' && field_array_column.identifier != 'ddi_phone_code' && field_array_column.identifier != 'mobile_phone_code'">
        
        
        
                    <div class="vx-row mb-6">
        
                      <div class="vx-col sm:w-1/5 w-full">
                        <span>{{ field_array_column.name }} </span>
                      </div>
                     
                      <div class="vx-col sm:w-2/3 w-full">
                        <div class="vx-col sm:w-2/3 w-full">
        
                          <!-- {{field_array_column}} -->
        
        
                          <template v-if="field_array_column.identifier == 'role'">
        
                            <v-select name="role" class="role" label="role"
                            :options="all_roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedContact[key]" />
                           </template>
                           
        
        
                           <template v-else-if="field_array_column.identifier == 'sub_role'">
        
                            <v-select name="sub_role" class="sub_role" label="sub_role"
                            :options="all_sub_roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedContact[key]" />
                           </template>
        
                           <template v-else-if="field_array_column.identifier == 'seniority'">
        
                            <div class="vx-col sm:w-1/3 w-full">
                              <v-select 
                                label="seniority" :options="all_seniorities" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="editSelectedContact[key]" />
                            </div>
                          </template>
        
                          <template v-else-if="field_array_column.identifier == 'ddi'">
        
        
                            <template
                            v-for="(w, index) in editSelectedContact[key]"
                          >
        
                            <div class="flex mb-4">
        
        
        
        
        
                              <div class="w-1/3 bg-grid-color-secondary h-12 mr-5">
                                <v-select
                                name="phone_code"
                                class="phone_code"
                                label="name_with_code"
                                :options="all_phone_codes"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="editSelectedContact[key][index]['ddi_phone_code']"
                              />
                                </div>
            
                                <div class="w-2/3 bg-grid-color-secondary h-12 mr-5">
                                  <vs-input
                                  class="w-full"
                                  name="phone"
                                  v-model="editSelectedContact[key][index]['ddi']"
                                />
                                </div>
                                
        
        
        
                               
        
        
                              
                              <div class="w-1/5 bg-grid-color h-12">
                                <vs-icon
                                  class="removeButton"
                                  @click="removeSelectedDDI(key, w)"
                                  color="success"
                                  icon="clear"
                                >
                                </vs-icon>
                              </div>
                            </div>
                          </template>
        
        
                      
                            <vs-button
                          @click="addDDI(field_array_column.column_id)"
                          color="primary"
                          type="filled"
                          >Add</vs-button
                        >
                          </template>
        
                          <template v-else-if="field_array_column.identifier == 'mobile'">
        
        
                            <template
                            v-for="(w, index) in editSelectedContact[key]"
                          >
        
                            <div class="flex mb-4">
        
        
        
                              <div class="w-1/3 bg-grid-color-secondary h-12 mr-5">
                                <v-select
                                name="phone_code"
                                class="phone_code"
                                label="name_with_code"
                                :options="all_phone_codes"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                v-model="editSelectedContact[key][index]['mobile_phone_code']"
                              />
                                </div>
            
                                <div class="w-2/3 bg-grid-color-secondary h-12 mr-5">
                                  <vs-input
                                  class="w-full"
                                  name="phone"
                                  v-model="editSelectedContact[key][index]['mobile']"
                                />
                                </div>
                                
        
        
        
                               
        
        
                              
                              <div class="w-1/5 bg-grid-color h-12">
                                <vs-icon
                                  class="removeButton"
                                  @click="removeSelectedMobile(key, w)"
                                  color="success"
                                  icon="clear"
                                >
                                </vs-icon>
                              </div>
                            </div>
                          </template>
        
        
                      
                            <vs-button
                          @click="addMobile(field_array_column.column_id)"
                          color="primary"
                          type="filled"
                          >Add</vs-button
                        >
                          </template>
        
        
                      
        
                        <template v-else-if="field_array_column.identifier == 'contact_social_media'">
        
                          <template
                          v-for="(w, index) in editSelectedContact[key]"
                        >
                        
                        
                          <div class="flex mb-4">
                            <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                              <vs-input
                                class="w-full"
                                name="contact_social_media"
                                v-model="editSelectedContact[key][index]['social_media']"
                                data-vv-as="contact_social_media"
                              />
                            </div>
                            <div class="w-1/5 bg-grid-color h-12">
                              <vs-icon
                                class="removeButton"
                                @click="removeSelectedSocialMedia(key, w)"
                                color="success"
                                icon="clear"
                              >
                              </vs-icon>
                            </div>
                          </div>
                        </template>
                        
                        <vs-button
                        @click="addSocialMedia(field_array_column.column_id)"
                        color="primary"
                        type="filled"
                        >Add</vs-button
                        >
                           
                        </template>
        
        
                        <template v-else-if="field_array_column.identifier == 'email'">
        
        
                          <template
                          v-for="(w, index) in editSelectedContact[key]"
                        >
        
        
                          <div class="flex mb-4">
                            <div class="w-3/4 bg-grid-color-secondary h-12 mr-5">
                              <vs-input
                                class="w-full"
                                name="email"
                                v-model="editSelectedContact[key][index]['email']"
                                data-vv-as="email"
                              />
                            </div>
                            <vs-icon
                            style="cursor: pointer"
                            @click="validateEmailZeroBounce(editSelectedContact[key][index]['email'])"
                            color="success"
                            icon="checkmark"
                          ></vs-icon>
                            <div class="w-1/5 bg-grid-color h-12">
                              <vs-icon
                                class="removeButton"
                                @click="removeSelectedEmail(key, w)"
                                color="success"
                                icon="clear"
                              >
                              </vs-icon>
                            </div>
                          </div>
        
                        </template>
        
        
        
        
                        <vs-button
                        @click="addEmail(field_array_column.column_id)"
                        color="primary"
                        type="filled"
                        >Add</vs-button
                      >
        
                      <span class="pl-20">{{ email_validate_status }}</span>
        
                           
                        </template>
        
                        
                        
        
        
        
                        <template v-else>
        
        
                          <template v-if="field_array_column.identifier == 'none_core_field'">
        
        
        
        
                            <template v-if="field_array_column.type == 'number'">
                              <input type="number" 
                                class="vs-input-class" v-model="editSelectedContact[key]" :name="field_array_column.column_id"
                                 :data-vv-as="field_array_column.column_id" />
        
                                
        
        
        
                              </template>
        
                              <template v-else-if="field_array_column.type == 'text' || field_array_column.type == 'client_contact'">
                                <vs-input
                                  class="w-full" v-model="editSelectedContact[key]" :name="field_array_column.column_id" v-validate="field_array_column.mandatory?'required':''"
                                   :data-vv-as="field_array_column.column_id" />
                                 
                              </template>
        
                              <template v-else-if="field_array_column.type == 'date'">
        
                                <flat-pickr
                                  :config="configDatePicker"
                                  placeholder="Choose Date"
                                  name="audit_date_time"
                                  v-model="editSelectedContact[key]"
                                />
                              </template>

                               <template v-else-if="field_array_column.type == 'datetime'">
        
                                <flat-pickr
                                  :config="configDateAndTimePicker"
                                  placeholder="Choose Date And Time"
                                  name="audit_date_and_time"
                                  v-model="editSelectedContact[key]"
                                />
                              </template>
        
                              <template v-else-if="field_array_column.type == 'choose_one'">
        
                                <span v-for="val, k in JSON.parse(field_array_column.values)">
        
                                  <input class="ml-4" :name="key" :value="val.value" type="radio" v-model="editSelectedContact[key]" />
                                  {{ val.value }}
                                </span>
                                <!-- <v-select
                                  label="value"
                                  :name="key"
                                  :options="JSON.parse(field_array_column.values)"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="editSelectedContact[key]"
                                  v-validate="'required'"
                                  data-vv-as="Action Type"
                                /> -->
                              </template>
        
                              <template v-else-if="field_array_column.type == 'dropdown'">
        
        
                                <v-select
                                  label="value"
                                  :name="key"
                                  :options="JSON.parse(field_array_column.values)"
                                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                  v-model="editSelectedContact[key]"
                                  v-validate="'required'"
                                  data-vv-as="Action Type"
                                />
                              </template>
        
                              <template v-else-if="field_array_column.type == 'checkbox'">
        
        
                                
        
                                <span v-for="(v, v_key) in JSON.parse(field_array_column.values)" class="p-2">
        
                                  
                      <input
                        type="checkbox"
                        class="mr-2"
                        :value="v.value"
                        :id="field_array_column.column_id"
                                  v-model="editSelectedContact[key]"
                        :checked="
                        editSelectedContact[key] != null &&
                        editSelectedContact[key].includes(v.value)
                        "
                       
                      />
        
                      {{ v.value }}
                    </span>
        
                              
                              </template>
        
                              <template v-else-if="field_array_column.type == 'textarea'">



                                <div :class="'textarea' + field_array_column.column_id">

                                  <vue-trumbowyg v-model="editSelectedContact[key]" 
                                :config="configs.basic"></vue-trumbowyg>

                  
                                  </div>

                               

        
        
                            </template>
                          </template>
        
                            <template v-else>
        
                             
        
        
                              <vs-input
                              class="w-full" v-model="editSelectedContact[key]" :name="field_array_column.column_id" 
                               :data-vv-as="field_array_column.column_id" />
                               
        
                            </template>
        
        
                       
                     
              
                     </template>
                          </div>
              </div>
                    </div>
                   </template>
        
        
                </template>
        
        
              </template>
    
            <div class="vx-row mb-10">
                <div class="vx-col sm:w-1/2 w-full"></div>
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-button @click.prevent="updateDetails">Submit</vs-button>
                </div>
            </div>
        </vs-popup>
    
        <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true" :preview-modal="false" :paginate-elements-by-height="1400" :filename="pdfFileName" :pdf-quality="2" :manual-pagination="false" pdf-content-width="1000px" pdf-format="a4" @hasDownloaded="hasDownloaded($event)" ref="html2Pdf" :html-to-pdf-options="opt">
            <section slot="pdf-content">
                <div id="editor-container">
                </div>
            </section>
        </vue-html2pdf>
    </div>
    </template>
    
    <script src="//cdn.ckeditor.com/4.20.1/standard/ckeditor.js"></script>
    <script>
    // Store Module
    import DataGrid from "@/components/aggrid/Aggrid.vue";
    import defineAbilitiesFor from "@/config/abilities";
    import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
    import VueHtml2pdf from 'vue-html2pdf'
    import Quill from 'quill'
    import axios from "@/axios.js";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
    import {
        quillEditor
    } from "vue-quill-editor";
    import vSelect from "vue-select";
    import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
    import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";



    import VueTrumbowyg  from 'vue-trumbowyg';
    import 'jquery-resizable-dom/dist/jquery-resizable.js';
    import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

    import 'trumbowyg/dist/trumbowyg.min.js';
    import 'trumbowyg/dist/ui/trumbowyg.min.css';
    import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
    import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
    import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
    import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
    import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
    import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
    import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
    import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
    import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
    import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
    import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
    import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'
    const utf8 = require('utf8');


    export default {
        beforeMount() {
            this.getDataSource();
        },
        data() {
            return {
              configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['strong', 'em'],
                    ['superscript', 'subscript'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
                all_seniorities : [],
                all_roles : [],
                all_sub_roles : [],
                all_currency_codes : [],
                all_verticals : [],
                all_sic_codes : [],
                all_countries : [],
                editSelectedContact : {},
                editSelectedAccount : {},
                email_validate_status: null,
                all_phone_codes: [],
                opt: {
                    margin: [15, 15, 5, 15],
                    image: {
                        type: 'jpeg',
                        quality: 0.98
                    },
                    html2canvas: {
                        scale: 3,
                        letterRendering: true,
                        useCORS: true
                    },
                    jsPDF: {
                        unit: 'pt',
                        format: 'letter',
                        orientation: 'landscape'
                    },
                    pagebreak: {
                        mode: ['avoid-all', 'css', 'legacy']
                    }
                },
                editClientViewPopUp: false,
                pdfFileName: null,
                docs_template_text: null,
                create_opportunity_docs_data: {},
                opportunity_document: {
                    campaign_id: null,
                    name: null,
                    description: null,
                    file_name: null
                },
                showOpportunityDocumentPopUp: false,
                columnDefs: [{
                        headerName: "Actions",
                        field: "transactions",
                        cellRenderer: "CellRendererActions",
                        suppressHeaderMenuButton: true,
                        pinned: true,
                        width: 100
                    },
                    {
                        headerName: "Campaign",
                        field: "campaign_name",
                        flex: 1,
                        filter: "agTextColumnFilter",
                        filterParams: {
                            buttons: ["apply", "reset"],
                            maxNumConditions: 4
                        },
                    },
                    {
                        headerName: "Campaign Code",
                        field: "campaign_code",
                        flex: 1,
                        filter: "agTextColumnFilter",
                        filterParams: {
                            buttons: ["apply", "reset"],
                            maxNumConditions: 4
                        }
                    },
                    {
                        headerName: "Company Name",
                        field: "company_name",
                        flex: 1,
                        filter: "agTextColumnFilter",
                        filterParams: {
                            buttons: ["apply", "reset"],
                            maxNumConditions: 4
                        }
                    },
                    {
                        headerName: "Forename",
                        field: "forename",
                        flex: 1,
                        filter: "agTextColumnFilter",
                        filterParams: {
                            buttons: ["apply", "reset"],
                            maxNumConditions: 4
                        }
                    },
                    {
                        headerName: "Surname",
                        field: "surname",
                        flex: 1,
                        filter: "agTextColumnFilter",
                        filterParams: {
                            buttons: ["apply", "reset"],
                            maxNumConditions: 4
                        }
                    },
                    {
                        headerName: "Opportunity",
                        field: "opportunity_name",
                        flex: 1,
                        filter: "agTextColumnFilter",
                        filterParams: {
                            buttons: ["apply", "reset"],
                            maxNumConditions: 4
                        }
                    },
                    // {
                    //     headerName: "Contact Name",
                    //     field: "contact_name",
                    //     flex: 1,
                    //     filter: "agTextColumnFilter",
                    //     filterParams: {
                    //         buttons: ["apply", "reset"],
                    //         maxNumConditions: 4
                    //     }
                    // }
                ],
                dataSource: {},
                records: [],
                selected: [],
                abilities: null,
                showSocial_mediaExtraField: false,
                showEmailExtraField: false,
                showMobileExtraField: false,
                showDdiExtraField: false,
                showLinkedExtraField: false,
                showPhoneExtraField: false,
                showWebsiteExtraField: false,
                website_counter: 0,
                configDateTimePicker: {
                    enableTime: false,
                    dateFormat: "Y-m-d"
                },
                configDatePicker: {
      enableTime: false,
      dateFormat: 'Y-m-d',
    },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
                showHeadOfficeCountryField: true,
                showHeadOfficeEditAutocomplete: false,
                showRegisteredOfficeCountryField: true,
                showRegisteredOfficeEditAutocomplete: false,
                showRegistrationJurisdictionField: true,
                showRegistrationJurisdictionEditAutocomplete: false,
                showParentField: true,
                showParentEditAutocomplete: false,
                showVerticalField: true,
                showVerticalEditAutocomplete: false,
                showSatelliteOfficeCountryField: true,
                showSatelliteOfficeEditAutocomplete: false,
                roles: [],
                seniorities: [],
                sub_roles: [],
                core_field_datas: {},
                contact_core_field_datas: {},
    
                websites: [{
                    counter: 0,
                    url: null
                }],
                linkedin_counter: 0,
    
                linkedins: [{
                    counter: 0,
                    url: null
                }],
                email_counter: 0,
    
                emails: [{
                    counter: 0,
                    email: null,
                    is_primary: null
                }],
                social_media_counter: 0,
    
                social_medias: [{
                    counter: 0,
                    social_media: "",
                    summary: null,
                    is_primary: null
                }],
                mobile_counter: 0,
    
                mobiles: [{
                    counter: 0,
                    mobile: "",
                    ddi_phone_code: null,
                    is_primary: null
                }],
                ddi_counter: 0,
    
                ddis: [{
                    counter: 0,
                    ddi: null,
                    ddi_phone_code: null,
                    is_primary: null
                }],
                phone_counter: 0,
    
                phones: [{
                    counter: 0,
                    phone_no: "",
                }],
                search: '',
                toggle: false,
                campaign_client_contacts: [],
                newCampaignClientContacts: [],
                master_field_datas: {},
                client_field_datas: {},
                campaign_field_datas: {},
                contact_master_field_datas: {},
                contact_client_field_datas: {},
                contact_campaign_field_datas: {},
                master_field_options: null,
                client_field_options: null,
                campaign_field_options: null,
                contact_master_field_options: null,
                contact_client_field_options: null,
                contact_campaign_field_options: null,
                checkedFields: {},
                contactCheckedFields: {},
                update_account_contact_data: {},
            }
        },
        components: {
            DataGrid,
            VueHtml2pdf,
            flatPickr,
            quillEditor,
            "v-select": vSelect,
            AccountAutocomplete,
            VueTrumbowyg
    
        },
        created() {
            var self = this;
            defineAbilitiesFor().then(function (data) {
                self.abilities = data;
            });
    
            let userInfo = JSON.parse(localStorage.getItem("userInfo"));
            this.user_id = userInfo["uid"];
            this.user_role = userInfo["userRole"];
    
            if (!moduleCampaignManagement.isRegistered) {
                this.$store.registerModule(
                    "campaignsManagement",
                    moduleCampaignManagement
                );
                moduleCampaignManagement.isRegistered = true;
            }
    
            if (!moduleContactsManagement.isRegistered) {
                this.$store.registerModule(
                    "contactsManagement",
                    moduleContactsManagement
                );
                moduleContactsManagement.isRegistered = true;
            }
    
        },
        mounted() {
            this.getPhoneTypes();
            this.getSeniority();
            this.getRoles();
            this.getPhoneTypes()
      this.getSeniority()
      this.getRoles()
      this.getAllPhoneCodes()
      this.getAllRoles();
    this.getAllSeniority();
    this.getAllSicCodes()
    this.getAllVerticals()
    this.getAllCurrencyCodes()
        },
        watch: {
            search(val) {
                let self = this
                self.newCampaignClientContacts = [];
                self.campaign_client_contacts.forEach(element => {
                    if (element.full_name.includes(val) && val != "") {
                        self.newCampaignClientContacts.push(element);
                    }
                });
    
                // console.log(self.newCampaignClientContacts)
    
                const key = 'uuid';
    
                self.newCampaignClientContacts = [...new Map(self.newCampaignClientContacts.map(item => [item[key], item])).values()];
    
            }
        },
        methods: {

            getAllSicCodes() {
     this.$store
        .dispatch("accountsManagement/getAllSicCodes")
        .then(response => {
          let data = response.data
          this.all_sic_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllVerticals() {
     this.$store
        .dispatch("accountsManagement/getAllVerticals")
        .then(response => {
          let data = response.data
          this.all_verticals = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllCurrencyCodes() {
     this.$store
        .dispatch("accountsManagement/getAllCurrencyCodes")
        .then(response => {
          let data = response.data
          this.all_currency_codes = data
          // let mappedArray = [];
          // for (const property in data) {
          //   mappedArray.push({
          //     id: data[property].id,
          //     name: data[property].code + ' - ' + data[property].description
          //   });
          // }
          // return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getAllPhoneCodes () {
      let self = this
      this.$store
        .dispatch('accountsManagement/getAllPhoneCodes')
        .then(response => {
          self.all_phone_codes = response.data
          self.all_countries = response.data
          self.all_phone_codes.forEach(function(ele){
            if(ele.phone_code){
              ele.name_with_code = ele.phone_code + ' - ' + ele.name_1
            }
            return ele
          })
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace('/login')
          }
        })
    },
            getRoles() {
                this.$store
                    .dispatch("contactsManagement/getRoles")
                    .then(res => {
                        this.roles = res.data;
                        // console.log(this.roles);
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            selectResult(client_contact) {
                let self = this
                self.search = client_contact.full_name;
                let dataObj = {}
                dataObj.full_name = client_contact.full_name
                dataObj.id = client_contact.uuid
    
                for (const property in self.contact_campaign_field_datas) {
                    if (self.contact_campaign_field_datas[property].type == "client_contact") {
                        self.contact_campaign_field_datas[property].value = dataObj
                    }
                }
            },
            stepSelectResult(client_contact) {
                let self = this
                self.search = client_contact.full_name;
    
                let dataObj = {}
                dataObj.full_name = client_contact.full_name
                dataObj.id = client_contact.uuid
                for (const property in self.contact_campaign_field_datas) {
                    if (self.contact_campaign_field_datas[property].type == "client_contact") {
                        self.contact_campaign_field_datas[property].value = dataObj
                    }
                }
            },
            search(val) {
                let self = this
                self.newCampaignClientContacts = [];
                self.campaign_client_contacts.forEach(element => {
                    if (element.full_name.includes(val) && val != "") {
                        self.newCampaignClientContacts.push(element);
                    }
                });
    
                const key = 'uuid';
    
                self.newCampaignClientContacts = [...new Map(self.newCampaignClientContacts.map(item => [item[key], item])).values()];
    
                // console.log("sdfsdf" , self.newCampaignClientContacts)
            },
            getAllRoles() {
      this.$store
        .dispatch("contactsManagement/getRoles")
        .then(res => {
          this.all_roles = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllSeniority() {
      this.$store
        .dispatch("contactsManagement/getSeniority")
        .then(res => {
          this.all_seniorities = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getAllSubRole(role_id) {
      this.$store
        .dispatch("contactsManagement/getSubRoles", role_id)
        .then(res => {
          this.all_sub_roles = res.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
            updateDetails() {
                 this.updateSDAccountAndClientViewAccount();
                this.updateSDContactAndClientViewContact();
          
                  this.$router.go(0);
            },
            updateSDAccountAndClientViewAccount() {
                let updateData = {};
                updateData.all_field_datas = this.editSelectedAccount

                updateData.sales_developer_id = this.user_id

                updateData.campaign_id = this.update_account_contact_data.campaign_id;
                updateData.account_id = this.update_account_contact_data.account_id;
                // updateData.updated_by_admin = 'yes'
            
    
                let self = this;
               
    
    
                this.$store
                    .dispatch("accountsManagement/updateSDQCAccount", updateData)
                    .then(res => {
                        // this.selectedEditCampaignId = null;
                        // this.selectedEditAccountId = null;
                        // this.$vs.notify({
                        //   color: "success",
                        //   title: "Sales Developer Account",
                        //   text: "The account was updated successfully."
                        // });
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            getPhoneTypes() {
                this.$store
                    .dispatch("accountsManagement/getPhoneTypes")
                    .then(res => {
                        this.phoneTypes = res.data;
                        this.phoneTypes = this.phoneTypes.filter(
                            item => item.slug != "head_office_switchboard" && item.slug != "site_switchboard"
                        );
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            updateSDContactAndClientViewContact() {    
                let updateData = {};
        
                updateData.all_contact_field_datas = this.editSelectedContact


                updateData.all_contact_field_datas.account_id = this.update_account_contact_data.account_id;
                updateData.all_contact_field_datas.contact_id = this.update_account_contact_data.contact_id;
                updateData.all_contact_field_datas.account_campaign_id = this.update_account_contact_data.campaign_id;

                
                // updateData.campaign_id = this.selectedEditCampaignId;
                // updateData.contact_id = this.selectedEditContactId;
                // updateData.sales_developer_id = this.user_id;
                // updateData.contact_status = this.selected_contact_status
                // updateData.contact_table_id = this.selected_contact_table_id
    
                updateData.campaign_id = this.update_account_contact_data.campaign_id;
                updateData.contact_id = this.update_account_contact_data.contact_id;
                updateData.sales_developer_id = this.user_id

                updateData.account_id = this.update_account_contact_data.account_id;
                // updateData.updated_by_admin = 'yes'
    
                let self = this;


                
                this.$store
                    .dispatch("accountsManagement/updateSDQCContact", updateData)
                    .then(res => {
                        this.selectedEditCampaignId = null;
                        this.selectedEditContactId = null;
                        this.$vs.notify({
                            color: "success",
                            title: "Details",
                            text: "The details was updated successfully."
                        });
    
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            updatePrimaryDdi(v, field_name) {
    
                this.contact_core_field_datas[field_name].forEach(function (m) {
                    m.is_primary = false
    
                    if (m.ddi == v.ddi) {
                        m.is_primary = true
                    }
    
                })
    
                this.ddis.forEach(function (m) {
                    m.is_primary = false
    
                    if (m.ddi == v.ddi) {
                        m.is_primary = true
                    }
    
                })
    
            },
            updatePrimaryMobile(v, field_name) {
    
    this.contact_core_field_datas[field_name].forEach(function (m) {
        m.is_primary = false

        if (m.mobile == v.mobile) {
            m.is_primary = true
        }

    })

    this.mobiles.forEach(function (m) {
        m.is_primary = false

        if (m.mobile == v.mobile) {
            m.is_primary = true
        }

    })

},
            updatePrimaryEmail(v, field_name) {
    
                this.contact_core_field_datas[field_name].forEach(function (m) {
                    m.is_primary = false
    
                    if (m.email == v.email) {
                        m.is_primary = true
                    }
    
                })
    
                this.emails.forEach(function (m) {
                    m.is_primary = false
    
                    if (m.email == v.email) {
                        m.is_primary = true
                    }
    
                })
    
            },
            updatePrimarySocialMedia(v, field_name) {


                // console.log(v.social_media)
    
                this.contact_core_field_datas[field_name].forEach(function (m) {
                    m.is_primary = false
    
                    if (m.social_media == v.social_media) {
                        m.is_primary = true
                    }
    
                })
    
                this.social_medias.forEach(function (m) {
                    m.is_primary = false
    
                    if (m.social_media == v.social_media) {
                        m.is_primary = true
                    }
    
                })


                // console.log("sdfsdfsdfsdf" , this.social_medias)
    
            },
            // updatePrimaryMobile(v, field_name) {
    
            //     this.contact_core_field_datas[field_name].forEach(function (m) {
            //         m.is_primary = false
    
            //         if (m.mobile == v.mobile) {
            //             m.is_primary = true
            //         }
    
            //     })
    
            //     this.mobiles.forEach(function (m) {
            //         m.is_primary = false
    
            //         if (m.mobile == v.mobile) {
            //             m.is_primary = true
            //         }
    
            //     })
    
            // },
            // addMobile() {
            //     if (this.mobiles.length == 1 && !this.showMobileExtraField) {
            //         this.showMobileExtraField = true;
            //     } else if (this.mobiles.length == 1 && this.showMobileExtraField) {
            //         this.mobiles.push({
            //             mobile: null,
            //             is_primary: null,
            //             counter: ++this.mobile_counter
            //         });
            //     } else {
            //         this.mobiles.push({
            //             mobile: null,
            //             is_primary: null,
            //             counter: ++this.mobile_counter
            //         });
            //     }
            // },
            addSocial_media() {
                if (this.social_medias.length == 1 && !this.showSocial_mediaExtraField) {
                    this.showSocial_mediaExtraField = true;
                } else if (
                    this.social_medias.length == 1 &&
                    this.showSocial_mediaExtraField
                ) {
                    this.social_medias.push({
                        url: null,
                        summary: null,
                        is_primary: null,
                        counter: ++this.social_media_counter
                    });
                } else {
                    this.social_medias.push({
                        url: null,
                        summary: null,
                        is_primary: null,
                        counter: ++this.social_media_counter
                    });
                }
            },
            editSDViewDetails(data) {
                this.update_account_contact_data = data
                this.editSDViewAccount(data)
                this.editSDViewContact(data)
                this.editClientViewPopUp = true;
    
            },
            getCountries(inputValue) {
                return this.$store
                    .dispatch("accountsManagement/getCountries", inputValue)
                    .then(response => {
                        let data = response.data;
                        let mappedArray = [];
                        for (const property in data) {
                            mappedArray.push({
                                id: data[property].id,
                                name: data[property].name_1
                            });
                        }
                        return mappedArray;
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            getVerticals(inputValue) {
                return this.$store
                    .dispatch("accountsManagement/getVerticals", inputValue)
                    .then(response => {
                        let data = response.data;
                        let mappedArray = [];
                        for (const property in data) {
                            mappedArray.push({
                                id: data[property].id,
                                name: data[property].vertical
                            });
                        }
                        return mappedArray;
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            getParentCompany(inputValue) {
                return this.$store
                    .dispatch("accountsManagement/searchAutocomplete", inputValue)
                    .then(response => {
                        let data = JSON.parse(JSON.parse(JSON.stringify(response.data)));
                        let mappedArray = [];
                        for (const property in data) {
                            mappedArray.push({
                                id: data[property].uuid,
                                name: data[property].company_name
                            });
                        }
                        return mappedArray;
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            editHeadOfficeCountry() {
                this.showHeadOfficeCountryField = false;
                this.showHeadOfficeEditAutocomplete = true;
                // console.log(this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent);
                this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true;
                this.$refs.EditHeadOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true;
                // this.$refs.EditHeadOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.head_office_country;
                // this.$refs.EditHeadOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.head_office_country;
            },
            editSatelliteOfficeCountry() {
                this.showSatelliteOfficeCountryField = false;
                this.showSatelliteOfficeEditAutocomplete = true;
                // console.log(this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent);
                this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true;
                this.$refs.EditSatelliteOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true;
                // this.$refs.EditSatelliteOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.satellite_office_country;
                // this.$refs.EditSatelliteOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.satellite_office_country;
            },
            editRegisteredOfficeCountry() {
                this.showRegisteredOfficeCountryField = false;
                this.showRegisteredOfficeEditAutocomplete = true;
                // console.log(this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent);
                this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent.isInFocus = true;
                this.$refs.EditRegisteredOfficeAutoComplete[0].$refs.suggestComponent.isClicking = true;
                // this.$refs.EditRegisteredOfficeAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
                // this.$refs.EditRegisteredOfficeAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
            },
            editRegistrationJurisdiction() {
                this.showRegistrationJurisdictionField = false;
                this.showRegistrationJurisdictionEditAutocomplete = true;
                // console.log(this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent);
                this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent.isInFocus = true;
                this.$refs.EditRegistrationJurisdictionAutoComplete[0].$refs.suggestComponent.isClicking = true;
                // this.$refs.EditRegistrationJurisdictionAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
                // this.$refs.EditRegistrationJurisdictionAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
            },
            editParent() {
                this.showParentField = false;
                this.showParentEditAutocomplete = true;
                // console.log(this.$refs.EditParentAutoComplete[0].$refs.suggestComponent);
                this.$refs.EditParentAutoComplete[0].$refs.suggestComponent.isInFocus = true;
                this.$refs.EditParentAutoComplete[0].$refs.suggestComponent.isClicking = true;
                // this.$refs.EditParentAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
                // this.$refs.EditParentAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
            },
            editVertical() {
                this.showVerticalField = false;
                this.showVerticalEditAutocomplete = true;
                // console.log(this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent);
                this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent.isInFocus = true;
                this.$refs.EditVerticalAutoComplete[0].$refs.suggestComponent.isClicking = true;
                // this.$refs.EditVerticalAutoComplete.$refs.suggestComponent.input.value = this.accountDescription.registered_office_country;
                // this.$refs.EditVerticalAutoComplete.$refs.suggestComponent.value = this.accountDescription.registered_office_country;
            },
            isValidJsonString(jsonString) {
                if (
                    !(
                        jsonString &&
                        typeof jsonString === "string" &&
                        typeof jsonString === "number"
                    )
                ) {
                    return false;
                }
    
                try {
                    JSON.parse(jsonString);
                    return true;
                } catch (error) {
                    return false;
                }
            },
            getSeniority() {
                this.$store
                    .dispatch("contactsManagement/getSeniority")
                    .then(res => {
                        this.seniorities = res.data;
                        console.log(this.seniorities);
                    })
                    .catch(err => {
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    })
            },
            hasDownloaded(e) {
                let self = this
                var file = new File([e], this.opportunity_document.name.replace(/\s/g, "-").toLowerCase() + '.pdf');
                let axois_url = this.$base_url + "/api/campaigns/upload_opportunity_document";
                let formData = new FormData();
                formData.append("file", file);
                axios
                    .post(axois_url, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    })
                    .then(response => {
                        if (response.data.status == "success") {
                            self.opportunity_document.file_name = response.data.data
                            self.addOpportunityDocument();
                            // console.log("response")
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    });
            },
            generateReport() {
                this.docs_template_text = this.create_opportunity_docs_data.docs.template_text
                
                //  replace unknown charcaters
                // this.docs_template_text = this.docs_template_text.replace(/�/g, "'")


                this.docs_template_text = utf8.decode(this.docs_template_text)

               
    
                // console.log(this.docs_template_text )
                // return false
    
                this.$refs.html2Pdf.filename = this.opportunity_document.name.replace(/\s/g, "-").toLowerCase();
                this.opt.filename = this.opportunity_document.name.replace(/\s/g, "-").toLowerCase();
                var div = document.getElementById('editor-container');
                // div.innerHTML = null    
                // S61: the template holds field values pasted in by the server; clean it before it goes on the page
                div.innerHTML += this.$sanitizeHtml(this.docs_template_text);
    
                const paragraphs = document.getElementById('editor-container').querySelectorAll('p');
    
                paragraphs.forEach(p => {
                        if (p.clientHeight >= 400) {
                            p.setAttribute("id", "id_to_remove");
                            const chunkSize = 135;
                            const str = p.innerText
                            const chunks = str.match(new RegExp(String.raw `\S(?:.{0,${chunkSize - 2}}\S)?(?= |$)`, 'g'));
                            var new_html = '<p>' + chunks.join('</p><p>') + '</p>';
    
                            div.innerHTML += this.$sanitizeHtml(new_html);
    
                            document.getElementById("id_to_remove").remove();
    
                        }
                    }
    
                );
                this.$refs.html2Pdf.generatePdf()
            },
            submitCreateDocumentForm() {
                let self = this
                self.$vs.loading();
                self.$validator.validateAll().then(result => {
                    if (result) {
    
                        self.generateReport()
                    }
                });
            },
            addOpportunityDocument() {
                // this.generateReport()
                this.opportunity_document.campaign_id = this.create_opportunity_docs_data.campaign_id
                this.$store.dispatch("campaignsManagement/addOpportunityDocument", this.opportunity_document)
                    .then(res => {
                        if (res.data.status == "fail") {
                            this.$vs.notify({
                                color: "danger",
                                title: "Opportunity Document",
                                text: res.data.message
                            });
    
                        } else {
                            this.$vs.notify({
                                color: "success",
                                title: "Opportunity Document",
                                text: res.data.message
                            });

                            this.$router.go(0);

    
                        }
                        this.$vs.loading.close();
                        this.showOpportunityDocumentPopUp = false
    
                    })
                    .catch(err => {
                        console.log(err);
    
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    });
            },
            editSDViewContact(contact) {
                let self = this;
                self.search = ''
    
                self.ddis = [{
                    counter: 0,
                    ddi: null,
                    is_primary: null
                }];
    
                self.showDdiExtraField = false;
    
                self.mobiles = [{
                    counter: 0,
                    mobile: null,
                    is_primary: null
    
                }];
    
                self.showMobileExtraField = false;
    
                self.emails = [{
                    counter: 0,
                    email: null,
                    is_primary: null
    
                }];
    
                self.showEmailExtraField = false;
    
                self.social_medias = [{
                    counter: 0,
                    social_media: null,
                    summary: null,
                    is_primary: null
    
                }];
    
                self.showSocial_mediaExtraField = false;
    
                self.contact_master_field_options = null;
                self.contact_client_field_options = null;
                self.contact_campaign_field_options = null;
                self.contact_master_field_datas = {};
                self.contact_client_field_datas = {};
                self.contact_campaign_field_datas = {};
    
                self.editSDAccountPopUp = false;
    
                self.editSDContactPopUp = true;
                // this.editSelectedAccount = account
                let data = {};
                data.contact_id = contact.contact_id;
                data.campaign_id = contact.campaign_id;
                data.update_opportunity_alert_contact_details = 'yes'

                // self.selectedEditCampaignId = contact.campaign_id;
                // self.selectedEditContactId = contact.contact_id;
    
                // self.selected_sd_account_id = contact.account_id;
                // self.selected_account_id = contact.account_id;
    
                // self.selected_contact_status = contact.contact_status;
                // self.selected_contact_table_id = contact.table_id;
    
                self.$store
                    .dispatch("accountsManagement/getSDViewContact", data)
                    .then(res => {
                        if (res.data) {
                            self.editSelectedContact = JSON.parse(res.data);

                            console.log("Contact" , self.editSelectedContact)


                            Object.keys(self.editSelectedContact).forEach(function (key) {


if (typeof self.editSelectedContact[key] === 'string' || self.editSelectedContact[key] instanceof String) {




if (self.editSelectedContact[key].startsWith('[') && self.editSelectedContact[key] != '[]') {




self.editSelectedContact[key] = JSON.parse(self.editSelectedContact[key])






}





}


let campaign_data_options = self.editSelectedContact['campaign_data_options']

campaign_data_options.forEach(function (ele) {
if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key) {
if (self.editSelectedContact[key] == null) {
self.editSelectedContact[key] = []
}
}

})



})






                         
                        }
                    })
                    .catch(err => {
                        console.log(err);
    
                        if (err.response.status === 404) {
                            this.editSelectedContact = true;
                            return;
                        }
                    });
    
                // var array = ["id","acc_id","campaign_id","contact_campaign_id","contact_id","contact_status","contact_id", "contact_status","contact_web"];
                // this.editSelectedContact = this.deleteKeys(contact, array);
                // console.log("Contact", this.editSelectedContact);
            },
            editSDViewAccount(account) {
    
                let self = this;
                self.websites = [{
                    counter: 0,
                    url: null
                }];
    
                self.showWebsiteExtraField = false;
    
                self.phones = [{
                    counter: 0,
                    phone_no: null
                }];
    
                self.showPhoneExtraField = false;
    
                self.linkedins = [{
                    counter: 0,
                    url: null
                }];
    
                self.showLinkedExtraField = false;
    
                self.master_field_options = null;
                self.client_field_options = null;
                self.campaign_field_options = null;
                self.master_field_datas = {};
                self.client_field_datas = {};
                self.campaign_field_datas = {};
                // self.editSDContactPopUp = false;
                // this.editSelectedAccount = account
                let data = {};
                data.account_id = account.account_id;
                data.campaign_id = account.campaign_id;
                data.update_opportunity_alert_account_details = 'yes'
                // self.selectedEditCampaignId = account.account_campaign_id;
                // self.selectedEditAccountId = account.acc_id;
                // self.selected_account_status = account.account_status;
                // self.selected_account_table_id = account.table_id;
    
                self.$store
                    .dispatch("accountsManagement/getSDViewAccount", data)
                    .then(res => {
                        if (res.data) {
                            self.editSelectedAccount = JSON.parse(res.data);



                            Object.keys(self.editSelectedAccount).forEach(function (key) {


if (typeof self.editSelectedAccount[key] === 'string' || self.editSelectedAccount[key] instanceof String) {




if (self.editSelectedAccount[key].startsWith('[')) {




self.editSelectedAccount[key] = JSON.parse(self.editSelectedAccount[key])






}





}


let campaign_data_options = self.editSelectedAccount['campaign_data_options']

campaign_data_options.forEach(function (ele) {
if (ele.identifier == 'none_core_field' && ele.type == 'checkbox' && ele.column_id == key) {
if (self.editSelectedAccount[key] == null) {
self.editSelectedAccount[key] = []
}
}

})



})





    
    
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
        
            addMobile (key) {

let self = this

Object.keys(self.editSelectedContact).forEach(function (k) {

  if (k == key){

    if (self.editSelectedContact[k] == null){
      self.editSelectedContact[k] = []
    }
    
    self.editSelectedContact[k].push({mobile_phone_code : null , mobile : null})

  }



})


},
    removeSelectedMobile (key,web) {
      let self = this

      Object.keys(self.editSelectedContact).forEach(function (k) {

        if (k == key){
          

          self.editSelectedContact[k] = self.editSelectedContact[k].filter(item => {

        return item != web
      })

        }



})
    },
    addDDI (key) {

let self = this

Object.keys(self.editSelectedContact).forEach(function (k) {

  if (k == key){

    if (self.editSelectedContact[k] == null){
      self.editSelectedContact[k] = []
    }
    
    self.editSelectedContact[k].push({ddi_phone_code : null , ddi : null , is_primary : false})

  }



})


},
    removeSelectedDDI (key,web) {
      let self = this

      Object.keys(self.editSelectedContact).forEach(function (k) {

        if (k == key){
          

          self.editSelectedContact[k] = self.editSelectedContact[k].filter(item => {

        return item != web
      })

        }



})
    },



    addPhone (key) {





let self = this

Object.keys(self.editSelectedAccount).forEach(function (k) {




  if (k == key){



    if (self.editSelectedAccount[k] == null){
      self.editSelectedAccount[k] = []
    }


    
    self.editSelectedAccount[k].push({phone_code : null , phone_no : null , phone_type : null})

  }



})


},
    removeSelectedPhone (key,web) {
      let self = this

      console.log(self.editSelectedAccount)

      console.log(key)



      Object.keys(self.editSelectedAccount).forEach(function (k) {

        if (k == key){



          

          self.editSelectedAccount[k] = self.editSelectedAccount[k].filter(item => {

        return item != web
      })

        }



})
    },
    removeSelectedWeb (key,web) {
      let self = this

      Object.keys(self.editSelectedAccount).forEach(function (k) {

        if (k == key){
          

          self.editSelectedAccount[k] = self.editSelectedAccount[k].filter(item => {

        return item != web
      })

        }



})
    },

    addWebsite (key) {





      let self = this

      Object.keys(self.editSelectedAccount).forEach(function (k) {

        if (k == key){

          if (self.editSelectedAccount[k] == null){
            self.editSelectedAccount[k] = []
          }
          
          self.editSelectedAccount[k].push({url : null})

        }



})


    },
    removeSelectedSocialMedia (key,social_media) {
  let self = this

  Object.keys(self.editSelectedContact).forEach(function (k) {

    if (k == key){
      

      self.editSelectedContact[k] = self.editSelectedContact[k].filter(item => {

    return item != social_media
  })

    }



})
},

addSocialMedia (key) {





  let self = this

  Object.keys(self.editSelectedContact).forEach(function (k) {

    if (k == key){

      if (self.editSelectedContact[k] == null){
        self.editSelectedContact[k] = []
      }


      
      self.editSelectedContact[k].push({social_media : null})

    }



})


},
    removeSelectedEmail (key,email) {
  let self = this

  Object.keys(self.editSelectedContact).forEach(function (k) {

    if (k == key){
      

      self.editSelectedContact[k] = self.editSelectedContact[k].filter(item => {

    return item != email
  })

    }



})
},

addEmail (key) {





  let self = this

  Object.keys(self.editSelectedContact).forEach(function (k) {

    if (k == key){

      if (self.editSelectedContact[k] == null){
        self.editSelectedContact[k] = []
      }


      
      self.editSelectedContact[k].push({email : null})

    }



})


},
    removeSelectedLinkedin (key,linkedin) {
  let self = this

  Object.keys(self.editSelectedAccount).forEach(function (k) {

    if (k == key){
      

      self.editSelectedAccount[k] = self.editSelectedAccount[k].filter(item => {

    return item != linkedin
  })

    }



})
},

addLinkedIn (key) {





let self = this

Object.keys(self.editSelectedAccount).forEach(function (k) {

  if (k == key){

    if (self.editSelectedAccount[k] == null){
      self.editSelectedAccount[k] = []
    }
    
    self.editSelectedAccount[k].push({url : null})

  }



})


},
    removeSelectedNewDdi (ddi) {
      this.ddis = this.ddis.filter(item => {
        return item.counter != ddi.counter
      })
    },
    removeSelectedDdi (ddi) {
      this.core_field_datas.ddi = this.core_field_datas.ddi.filter(item => {
        return item.ddi != ddi
      })
    },
    
          
            validateEmailZeroBounce(email) {
                let self = this
    
                if (email) {
                    self.$vs.loading();
    
                    this.$store
                        .dispatch("contactsManagement/validateEmailZeroBounce", email)
                        .then(res => {
                            self.email_validate_status = res.data
                            self.$vs.loading.close();
    
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
    
            },
        
        
            emailOpportunityAlert(data) {
    
                // alert("Sdfsdfsdf")
                // this.opportunity_document = {
                //   campaign_id: null,
                //   name: null,
                //   description: null,
                //   file_name: null
                // }
                // this.showOpportunityDocumentPopUp = true
                // this.create_opportunity_docs_data = data
    
                // console.log(data)
    
                if (data.email.length == 0) {
    
                    this.$vs.notify({
                        color: "warning",
                        title: "Email Template",
                        text: "No Email Template Selected"
                    });
    
                    return false
                }
    
                this.$vs.loading();
                let formData = {}
                formData.campaign_id = data.campaign_id
                formData.message = data.email.template_text
                formData.subject = data.email.template_subject
                formData.alert_opportunity_owner = data.alert_opportunity_owner
                formData.account_id = data.account_id
                formData.contact_id = data.contact_id
                // Release 1: which opportunity this alert is for, so its owner can be emailed
                formData.opportunity_id = data.opportunity_id
                this.$store.dispatch("campaignsManagement/emailOpportunityAlert", formData)
                    .then(res => {
                        if (res.data.status == "fail") {
                            this.$vs.notify({
                                color: "danger",
                                title: "Email Opportunity Alert",
                                text: res.data.message
                            });
    
                        } else {
                            this.$vs.notify({
                                color: "success",
                                title: "Email Opportunity Alert",
                                text: res.data.message
                            });
                            this.$router.go(0);
    
                        }
                        this.$vs.loading.close();
                        this.showOpportunityDocumentPopUp = false
    
                    })
                    .catch(err => {
                        // console.log(err);
    
                        if (err.response.status === 401) {
                            this.$router.replace("/login");
                        }
                    });
    
                // console.log("dfssdf", data)
            },
    
            createOpportunityDocsFile(data) {
    
                if (data.docs.length == 0) {
    
                    this.$vs.notify({
                        color: "warning",
                        title: "Docs Template",
                        text: "No Docs Template Selected"
                    });
    
                    return false
                }
    
                this.opportunity_document = {
                    campaign_id: null,
                    name: null,
                    description: null,
                    file_name: null
                }
                this.showOpportunityDocumentPopUp = true
                this.create_opportunity_docs_data = data
                // console.log("dfssdf", data)
            },
            getDataSource() {
                var self = this;
                this.dataSource = {
                    getRows(params) {
                        // console.log(params.request)
    
                        self.$store
                            .dispatch(
                                "campaignsManagement/getAllOpportunityAlerts",
                                params.request
                            )
                            .then(function (response) {
                                let response_data = response.rows;
    
                                console.log("sdfsdfsdf" , response_data)
    
                                if (response_data.length != 0) {
                                    self.$refs.OpportunityAlerts.gridApi.hideOverlay();
                                    params.success({ rowData: response.rows , rowCount: response.lastRow })
                                } else {
                                    self.$refs.OpportunityAlerts.gridApi.showNoRowsOverlay();
                                    return params.success({ rowData: [] })
                                }
                            })
                            .catch(err => {
                                console.error(err);
                            });
                    }
                };
            },
            goBack: function () {
                this.$router.go(-1);
            },
        }
    };
    </script>
    
    <style scoped>

    .vs-input-class{
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.2);
        font-size: 1rem;
        height: 38px;
        padding-left: 10px;
        padding-right: -10px;
        border-radius: 4px;
        background: transparent;
        transition: all .2s ease;
      
      
      }
    .removeButton {
        cursor: pointer;
    }
    
    .removeButtonClass {
        cursor: pointer;
        position: relative;
        float: right;
        margin-top: -25px;
        margin-right: 25px;
    }
    
    .vs-textarea {
        height: 800px !important;
    
    }
    
    /* #editor-container {
      padding: 15px;
    } */
    </style>